module.exports = __webpack_public_path__ + "img/kir_no.630c76a3.png";